import { VText } from '@vake/ui-kit';
import React from 'react';

interface NotFoundProps {
    location: string;
}

const NotFound: React.FC<NotFoundProps> = ({ location }) => {
    return (
        <div className="text-center content-center w-screen h-screen">
            <VText variant="Di2">404 Not Found</VText>
            <VText>
                The page at <code>{location}</code> could not be found.
            </VText>
        </div>
    );
};

export default NotFound;
